import React, { Component } from 'react';
import * as utils from '../../../../../../../utils';
import TimeEntryInfoBullet from './TimeEntryInfoBullet/TimeEntryInfoBullet';
import './TimeEntryInfoContent.css';
import { SPECIAL_BULLETS } from '../../../../../../../texts';

class TimeEntryInfoContent extends Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.data.pos !== undefined;
  }

  render() {
    const { active, data, spotId } = this.props;
    const isSpecial = data.section !== undefined;

    let title = '';
    const bullets = [];

    if (active) {
      if (isSpecial) {
        title = spotId === 0 ? SPECIAL_BULLETS.START : SPECIAL_BULLETS.END;
      } else {
        title = utils.minutesToTimeString(data.time);
        for (let t = 0; t < data.map.top.length; t += 1) {
          if (data.map.top[t].hidden !== true) {
            bullets.push(
              <TimeEntryInfoBullet
                key={`${spotId}-0-${t}`}
                data={data.map.top[t]}
              />
            );
          }
        }
        for (let b = 0; b < data.map.bottom.length; b += 1) {
          if (data.map.bottom[b].hidden !== true) {
            bullets.push(
              <TimeEntryInfoBullet
                key={`${spotId}-1-${b}`}
                data={data.map.bottom[b]}
              />
            );
          }
        }
      }
    }

    return (
      <React.Fragment>
        {active && (
          <div className="info-content">
            <div className="title">{title}</div>
            <div>{bullets}</div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default TimeEntryInfoContent;



// WEBPACK FOOTER //
// ./src/components/App/Dukla/Scene/SceneUI/TimeEntryInfo/TimeEntryInfoContent/TimeEntryInfoContent.js